if (!customElements.get('variant-selects')) {
  customElements.define(
    'variant-selects',
    class VariantSelects extends HTMLElement {
      constructor() {
        super();
      }

      get selectedOptionValues() {
        return Array.from(this.querySelectorAll('select option[selected], fieldset input:checked')).map(
          ({ dataset }) => dataset.optionValueId
        );
      }

      getInputForEventTarget(target) {
        return target.tagName === 'SELECT' ? target.selectedOptions[0] : target;
      }

      connectedCallback() {
        this.addEventListener('change', (event) => {
          const target = this.getInputForEventTarget(event.target);
          this.updateSelectedSwatchValue(event);

          // Safely publish event if pubsub exists
          if (window.FoxTheme && window.FoxTheme.pubsub && window.FoxTheme.pubsub.publish && window.FoxTheme.pubsub.PUB_SUB_EVENTS && window.FoxTheme.pubsub.PUB_SUB_EVENTS.optionValueSelectionChange) {
            window.FoxTheme.pubsub.publish(window.FoxTheme.pubsub.PUB_SUB_EVENTS.optionValueSelectionChange, {
              data: {
                event,
                target,
                selectedOptionValues: this.selectedOptionValues,
              },
            });
          }
        });
      }

      updateSelectedSwatchValue({ target }) {
        const { value, name, tagName } = target;

        if (tagName === 'SELECT' && target.selectedOptions.length) {
          Array.from(target.options)
            .find((option) => option.getAttribute('selected'))
            ?.removeAttribute('selected');
          target.selectedOptions[0].setAttribute('selected', 'selected');

          const swatchValue = target.selectedOptions[0].dataset.optionSwatchValue;
          const swatchValueContainerSelect = target.closest('.product-form__input');
          const selectedDropdownSwatchValue = swatchValueContainerSelect?.querySelector('[data-selected-value] > .swatch');

          if (selectedDropdownSwatchValue) {
            if (swatchValue) {
              selectedDropdownSwatchValue.style.setProperty('--swatch--background', swatchValue);
              selectedDropdownSwatchValue.classList.remove('swatch--unavailable');
            } else {
              selectedDropdownSwatchValue.style.setProperty('--swatch--background', 'unset');
              selectedDropdownSwatchValue.classList.add('swatch--unavailable');
            }
            selectedDropdownSwatchValue.style.setProperty(
              '--swatch-focal-point',
              target.selectedOptions[0].dataset.optionSwatchFocalPoint || 'unset'
            );
          }

          // Update the data-selected-swatch-value attribute on the span
          const swatchValueSpanSelect = swatchValueContainerSelect?.querySelector('[data-selected-swatch-value]');
          if (swatchValueSpanSelect) {
            const selectedValue = target.selectedOptions[0].value;
            swatchValueSpanSelect.dataset.selectedSwatchValue = selectedValue;
            // Also update text content if needed (based on original Liquid)
            swatchValueSpanSelect.textContent = selectedValue;
          }

        } else if (tagName === 'INPUT' && target.type === 'radio') {
          const swatchValueContainer = target.closest('.product-form__input');
          const selectedSwatchValueTextEl = swatchValueContainer?.querySelector('[data-selected-value]');
          if (selectedSwatchValueTextEl) selectedSwatchValueTextEl.textContent = value;

          // Update the data-selected-swatch-value attribute as well
          const swatchValueSpan = swatchValueContainer?.querySelector('[data-selected-swatch-value]');
          if (swatchValueSpan) {
            swatchValueSpan.dataset.selectedSwatchValue = value;
            // Update text content here too for consistency
            swatchValueSpan.textContent = value;
          }
        }
      }
    }
  );
}
